import { useState, useEffect } from 'react';
import { TaskStatus } from '../../services/TaskStatus';
import {
    WorkflowTasks,
    SecondaryTasks,
    AuthorizeTasks,
    ConfirmIdTasks,
    ReviewTasks,
    FiledTasks,
    VirReviewTasks,
    VIRCCPaymentTasks,
    VIRCCDocumentsTasks
} from '../../services/WorkflowTasks';
import { TicketType } from '../../services/TicketType';
import { supportsReturnReview } from '../../../../strategies/TicketTypeStrategy';

export const useTicketStatus = (ticket) => {
    const [stateTasks, setStateTasks] = useState([]);
    const [ticketStatus, setTicketStatus] = useState(null)
    const getTaskCompletions = (t, taskId) => {
        let taskCompletions = (t ? t.taskCompletionStates : []) || []
        return taskCompletions.filter(x => x.workflowTaskId === taskId);
    }
    const getRelatedTasks = (taskId) => {
        var relatedTasks = []
        if (taskId === WorkflowTasks.AUTHORIZE_CRA) {
            relatedTasks = AuthorizeTasks
        } else if (taskId === WorkflowTasks.CONFIRM_ID) {
            relatedTasks = ConfirmIdTasks
        } else if (taskId === WorkflowTasks.RETURN_REVIEWED && supportsReturnReview(ticket?.ticketType?.identifier)) {
            relatedTasks = ReviewTasks
        } else if (taskId === WorkflowTasks.RETURN_REVIEWED && ticket.ticketType.identifier === TicketType.VIR ) {
            relatedTasks = VirReviewTasks
        } else if (taskId === WorkflowTasks.VIR_CONFIRM_UPLOAD) {
             relatedTasks = VIRCCDocumentsTasks
        } else if (taskId === WorkflowTasks.VIR_READY_TO_FILE ) {
            relatedTasks = VIRCCPaymentTasks
        } else if (taskId === WorkflowTasks.RETURN_FILED) {
            relatedTasks = FiledTasks
        }
        return relatedTasks.filter(r => r !== taskId);
    }

    useEffect(() => {
        // get the tasks needed to reach the next state
        var transitionTasks = (ticket ? ticket.workflowStateTransitionTasks : null) || []
        
        // We show consolidated statii - filter out spouse and rq secondary tasks
        // filter out the ones without a target as they will be additional tasks 
        var primaryTasks = [];        
        primaryTasks = transitionTasks.filter(tt => !SecondaryTasks.includes(tt.workflowTask.identifier)
        && tt.targetType != null)
        
        // now see if we have completion info for any of them
        let st = []

        primaryTasks.forEach(t => {
            let tc = getTaskCompletions(ticket, t.workflowTask.identifier)

            let task = {}
            if (tc.some(x => x.status === TaskStatus.COMPLETE)) {
                task = { identifier: t.workflowTask.identifier, status: TaskStatus.COMPLETE }
            } else if (tc.some(x => x.status === TaskStatus.FAILED)) {
                task = { identifier: t.workflowTask.identifier, status: TaskStatus.FAILED }
            } else if (tc.some(x => x.status === TaskStatus.IN_PROGRESS)) {
                task = { identifier: t.workflowTask.identifier, status: TaskStatus.IN_PROGRESS }
            } else {
                task = { identifier: t.workflowTask.identifier, status: TaskStatus.NOT_STARTED}
            }

            if (task.status !== TaskStatus.FAILED) {
                // fine related tasks (ie spouse and rq versions and update the stated based on whether
                // they're required and or completed
                var relatedTasks = getRelatedTasks(t.workflowTask.identifier);
                
                relatedTasks.forEach(u => {
                    if (transitionTasks.some(tt => tt.workflowTask.identifier === u)) {
                        let tc = getTaskCompletions(ticket, u)
                        if (tc.some(x => x.status === TaskStatus.COMPLETE)) {
                            // if one related task is complete, the whole thing is in progress
                            if (task.status !== TaskStatus.COMPLETE) {
                                task.status = TaskStatus.IN_PROGRESS
                            }
                        } else if (tc.some(x => x.status === TaskStatus.FAILED)) {
                            // if any task failed, the whole thing failed
                            task.status = TaskStatus.FAILED
                        } else if (tc.some(x => x.status === TaskStatus.IN_PROGRESS)) {
                            // at least one related tasks is in progress, so the whole thing is
                            if (task.status !== TaskStatus.IN_PROGRESS) {
                                task.status = TaskStatus.IN_PROGRESS
                            }
                        } else {
                            if (task.status === TaskStatus.COMPLETE) {
                                task.status = TaskStatus.IN_PROGRESS
                            }
                        }
                    }                     
                })
            } 
            st.push(task)
        })
        
        if (ticket?.ticketType.identifier === TicketType.VIR) {
            let ccDocNotCompleted = st.filter(tt => tt.identifier == "RETURN_REVIEWED" && (tt.status == TaskStatus.IN_PROGRESS || tt.status == TaskStatus.NOT_STARTED));
            if (ccDocNotCompleted?.length > 0) {
                for (var i = st.length - 1; i >= 0; i--) {
                    if (st[i].identifier === WorkflowTasks.VIR_READY_TO_FILE) {
                        st.splice( i , 1);
                    }
                }
            }
            let retReviewed = st.filter(tt => tt.identifier == "RETURN_REVIEWED");
            if (retReviewed?.length > 0) {
                retReviewed[0].identifier = "RETURN_REVIEWED_VIR"            
            }

        }
     
        setStateTasks(st);

        setTicketStatus((ticket && ticket.ticketState) ? ticket.ticketState.identifier : null);

    }, [ticket])

    return [ stateTasks, ticketStatus ];
}
